export default __webpack_public_path__ + "static/media/close-icon.88f7c353.svg";